import GridViewIcon from "@mui/icons-material/GridView";
import PersonOutlineIcon from "@mui/icons-material/PersonOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutlined";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import BookmarksIcon from "@mui/icons-material/Bookmarks";
import WidgetsIcon from "@mui/icons-material/Widgets";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import PollOutlinedIcon from "@mui/icons-material/PollOutlined";
import { checkRole } from "../../hoc";
import { MenuItem, MenuSection } from "../molecules";
import { PATHS } from "../../constants/paths";

const BasicsSubmenu = () => {
  const isProjectManager = checkRole("project_manager");
  const isSuperAdmin = checkRole("superadmin");
  const isServiceUser = checkRole("service_user");

  return (
    <MenuSection label="Backoffice">
      <MenuItem
        path={PATHS.Dashboard.Path}
        iconClass="udo-icon-dashboard"
        label="Dashboard"
        Icon={GridViewIcon}
      />
      <MenuItem
        path={PATHS.Customers.Path}
        label="Customers"
        Icon={PersonOutlineIcon}
      />
      {isProjectManager && (
        <MenuItem
          path={PATHS.Users.Path}
          label="Users"
          Icon={PeopleOutlineIcon}
        />
      )}
      {isProjectManager && (
        <MenuItem
          path={PATHS.MailAmbition.Path}
          label="MailAmbition"
          Icon={MailOutlineIcon}
        />
      )}
      {isProjectManager && (
        <MenuItem
          path={PATHS.AppConfig.Path}
          label="UDO config"
          Icon={DisplaySettingsIcon}
        />
      )}
      {isProjectManager && (
        <MenuItem
          path={PATHS.Manual.Path}
          label="UDO manual"
          Icon={BookmarksIcon}
        />
      )}
      {isSuperAdmin && (
        <MenuItem
          path={PATHS.Agents.Path}
          label="Agents"
          Icon={AutoAwesomeIcon}
        />
      )}
      {isServiceUser && (
        <MenuItem path={PATHS.Data.Path} label="Data" Icon={PollOutlinedIcon} />
      )}
      {isSuperAdmin && (
        <MenuItem
          path={PATHS.Widgets.Path}
          label="Widgets"
          Icon={WidgetsIcon}
        />
      )}
    </MenuSection>
  );
};

export { BasicsSubmenu };
